import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltySimilarService } from '../novelty-similar-service';
import { NoveltySimilarRepository } from '../../repositories/novelty-similar-repository';
import type { PatentProfileWithMatchedTechFeature } from '../../types';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class NoveltySimilarServiceImpl implements NoveltySimilarService {
    constructor(
        @inject(NoveltySimilarRepository)
        private readonly _noveltySimilarRepository: NoveltySimilarRepository,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) { }

    async updateNoveltySimilarList(payload: {techFeatures: PatentProfileWithMatchedTechFeature[], isPatentConfirm?: boolean}): Promise<PatentProfileWithMatchedTechFeature[]> {
        return this._noveltySimilarRepository.updateNoveltySimilarList({
            taskId: this._currentTaskService.taskId,
            techFeatures: payload.techFeatures,
            isPatentConfirm: payload.isPatentConfirm,
        });
    }

    async getFeatureComparison(payload:{pns: string[]; isAddPatent?: boolean,addPatentSelected?:boolean }): Promise<PatentProfileWithMatchedTechFeature[]> {
        return this._noveltySimilarRepository.getFeatureComparison( {
            task_id:this._currentTaskService.taskId,
            patent_pns: payload.pns,
            is_add_patent:payload.isAddPatent,
            add_patent_selected:payload.addPatentSelected,
        });
    }
}
